import { render } from "./PointSetting.vue?vue&type=template&id=d9b80bea&scoped=true&ts=true"
import script from "./PointSetting.vue?vue&type=script&lang=ts"
export * from "./PointSetting.vue?vue&type=script&lang=ts"

import "./PointSetting.vue?vue&type=style&index=0&id=d9b80bea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9b80bea"]])

export default __exports__